import { doc } from 'firebase/firestore';
import { useDispatch, useSelector } from 'react-redux';
import { useGeneral } from '../../context/generalContext';
import { Adddata, db, updateRevision } from '../../data/index';
import { modalClose, modalOpen } from '../../store/openModal/OpenModalSlices';
import { SlackErrorHandle, ToastError, ToastSucces, ToastWarn } from '../tools/index';
import { useEffect, useState } from 'react';
import { CreateOrder, NotificationModal } from './index';
import { addModification } from '../../store/orderData/OrderDataSlices';
import { useCommerceConfig } from '../../hooks';

export const OrderDetailButtons = ({ closeSection }) => {
   
    const userData = useSelector((state) => state.user)
    const orderInfo = useSelector((state) => state.orderData)
    const isOpenModal = useSelector(state => state.openModal)
    const sapConnected = useSelector(state => state.sapConnected)
    const clients = useSelector(state => state.clients)
    const downloading = useSelector((state) => state.downloadElements)
    const [cargandoSap, setCargandoSap] = useState(false)
    const [autorizando, setAutorizando] = useState(false)
    const [taxes, setTaxes] = useState([])
    const [disabledBtn, setDisabledBtn] = useState(true)
    const [showSapWarningModal, setShowSapWarningModal] = useState(false)

    // revisar
    const [dis, setDis] = useState(true)

    const dispatch = useDispatch()
    //Instancia para conexion con el service Layer
    const { uploadtoServiceLayer, pedidosCollectionFirebase, datacred, Sl, getToday } = useGeneral()
    const commerceConfig = useCommerceConfig(orderInfo.CommerceId)
    const requiresFinalValidation = Boolean(commerceConfig.orderFormConfig?.requiresFinalValidation)
    const isValidator = userData.Permiso === 'Administracion' && Boolean(userData.EsValidador)
    const canReviewAuthorizedOrder = ['Direccion', 'Gerencia'].includes(userData.Permiso)
    const canValidateAuthorizedOrder = isValidator && requiresFinalValidation
    const isDirector = userData.Permiso === 'Direccion'
    const directorCanSendWithoutValidation =
        isDirector && requiresFinalValidation && orderInfo.Estado === 'Autorizado'
    const directorCanSendValidated =
        isDirector && (
            (requiresFinalValidation && orderInfo.Estado === 'Validado')
            || (!requiresFinalValidation && orderInfo.Estado === 'Autorizado')
        )
    const isCurrentUserOrderOwner =
        orderInfo.VendedorApellido === userData.Apellido
        || orderInfo.Vendedor === userData.Apellido
        || orderInfo.Vendedor === `${userData.Nombre} ${userData.Apellido}`
    const isCurrentUserReviewer =
        orderInfo.Revision === userData.Apellido
        || orderInfo.Revision === `${userData.Nombre} ${userData.Apellido}`
    const canManagerModifyAuthorizedOrder =
        userData.Permiso === 'Gerencia'
        && orderInfo.Estado === 'Autorizado'
        && (isCurrentUserOrderOwner || isCurrentUserReviewer)
    const canShowActionSection =
        ['Pendiente', 'Autorizado', 'Validado'].includes(orderInfo.Estado)
        && (
            !['Vendedor', 'Administracion'].includes(userData.Permiso)
            || canValidateAuthorizedOrder
        )
    const canRejectOrder =
        canReviewAuthorizedOrder
        || canValidateAuthorizedOrder
    const isValidationRejectionFlow =
        requiresFinalValidation
        && orderInfo.Estado === 'Autorizado'
        && canRejectOrder
    const canSellerModifyPendingOrder =
        userData.Permiso === 'Vendedor'
        && ['Pendiente', 'Preliminar'].includes(orderInfo.Estado)

    //console.log(orderInfo.proforma)
    //TODO: probar con sap
    //funcion para cambiar el estado del pedido (aceptado / rechazado)
    const handleOrderState = async (name) => {
        setDisabledBtn(true)
        ToastWarn('Procesando carga...')
        try {
            //Si el boton es cargar a sap entonces enviar a Service Layer
            if (name === 'Cargado en SAP') {
                setCargandoSap(true)
                try {
                    // subida de proforma al pedido 
                    let prof = calculateTaxes()

                   // sube primero la orden a sap agregando los datos de proforma y actualiza firebase
                    await uploadtoServiceLayer({ ...orderInfo, Proforma: prof }, userData.Apellido)

                    //TODO: probar uploadtoServiceLayer sube a firebase tambien
                    //luego actualiza en firebase
                    await Adddata(
                        doc(db, pedidosCollectionFirebase, orderInfo.ID),
                        { Proforma: prof }
                    )
                    closeSection()
                } catch (error) {
                    ToastError(`fallo en la carga ${error}`)
                    SlackErrorHandle(`${new Date()}: -> fallo en la carga -> ${error} -> order Id : ${orderInfo.ID}`)
                }

            } else {
                setAutorizando(true)
                await updateRevision(
                    pedidosCollectionFirebase,
                    orderInfo.ID,
                    userData.Apellido,
                    name,
                    undefined,
                    {
                        RejectionReasonCode: '',
                        RejectionReasonLabel: '',
                        RejectionReasonNote: '',
                    }
                )

                closeSection()
                ToastSucces(name === 'Validado' ? 'Orden Validada' : 'Orden Autorizada')
            }
        } catch (error) {
            ToastError('error al cargar en sap')
            // console.log(error)
            SlackErrorHandle(`${new Date()}: -> error al cargar en sap -> ${error} -> order Id : ${orderInfo.ID}`)
        }
    }

    // funcion que activa los botones segun sea el caso
    const disableButton = () => {
        let disabled = true
        
        //estado pendiente
        if (orderInfo.Estado === 'Pendiente' && canReviewAuthorizedOrder) {
            disabled = false
        } else if (canManagerModifyAuthorizedOrder) {
            disabled = false
        } else if (orderInfo.Estado === 'Autorizado' && (canValidateAuthorizedOrder || isDirector)) {
            disabled = false
        } else if (orderInfo.Estado === 'Validado' && isDirector) {
            disabled = false
        } else if (!cargandoSap) {
            disabled = false
        }

        return disabled
    }

    const handleModifications = () => {
        dispatch(modalOpen({ b: true }))
        dispatch(addModification({
            Apellido: userData.Apellido,
            UID: userData.UID,
            fecha: new Date().toLocaleDateString()
        }))
    }

    const closeModificationModal = () => {
        dispatch(modalClose())
    }

    const handleSapClick = () => {
        if (directorCanSendWithoutValidation) {
            setShowSapWarningModal(true)
            return
        }

        handleOrderState('Cargado en SAP')
    }

    /**************************************** */
    //get impuestos por cliente, codigos, fecha 
    //calculos de impuestos
    useEffect(() => {
        setCargandoSap(true)
        const fetchData = async () => {
          
            if (
                sapConnected
                && !Object.values(downloading).includes(false)
                && !["Cargado en SAP", "Rechazado", "Validacion rechazada"].includes(orderInfo.Estado)
            ) {
                
                let cliente = clients.find((e) => e.CUIT === orderInfo.Cuit).Cliente_ID
               
                try {
                    const getTaxes = async (url, ServiceLayer, cliente) => {
                        
                        let date = getNewToday()

                        try {
                            const urldata = `sml.svc/PV_CLIENTES_IMPUESTOS?$filter=CardCode eq '${cliente}' and (WTCode eq 'P007' or WTCode eq 'P013' or WTCode eq 'PC01' or WTCode eq 'PC02' or WTCode eq 'P016') and DateTo gt '${date}' `
                            //console.log(urldata)   '28345'
                            const res = await ServiceLayer(url).get(urldata)

                            return (res.data.value)
                        } catch (error) {
                            // console.log(error.response.data.error.message.value)
                            throw error
                        }
                    }
                    try {
                        //console.log(datacred)
                        let taxes = await getTaxes(datacred.BaseURL, Sl, cliente)
                        
                        setTaxes(taxes)

                    } catch (error) {
                        // console.log(error.message)
                    }
                } catch (error) {
                    // console.log(error.message)
                } finally {
                    setCargandoSap(false)
                }
            }
        }
        fetchData()

    }, [downloading])

    const getNewToday = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Asegura que el mes tenga dos dígitos
        const day = String(today.getDate()).padStart(2, '0'); // Asegura que el día tenga dos dígitos
        return `${year}-${month}-${day}`;
    };
    //calcula los impuestos
    const calculateTaxes = () => {  
        let clienteCat = clients.find((e) => e.CUIT === orderInfo.Cuit).Cat_IIBB
        let clienteIvaEx = clients.find((e) => e.CUIT === orderInfo.Cuit).Iva
        let liquid = clients.find((e) => e.CUIT === orderInfo.Cuit).liquidaIva

        let realyTotal = clienteIvaEx === 'EX' ? orderInfo.sumTotalConIvaTripl : orderInfo.SubTotal;

        let proforma = {
            numProforma: 'P-' + orderInfo.Num_pedido,
            fecha: new Date().toLocaleDateString(),
            P007: 0,
            P013: 0,
            PC01: 0,
            PC02: 0,
            P016: 0,
            PC05: 0,
            PC06: 0,
            PC07: 0,
            PC08: 0,
            PorcentajeIBB:{},
        }
        // console.log(proforma)
        // console.log(proforma)
        // PC05 = Subtotal * Tasa/100
        // PC06 = Subtotal * 50 / 100 * Tasa/100
        // PC07 = Subtotal + IVA * Tasa/100
        // PC06 = Subtotal + IVA * 50 / 100 * Tasa/100
        let impSum =  clienteIvaEx === 'EX' ? 0 : orderInfo.IVA21

        if (taxes) {
            taxes.map((t) => {
                if (t.Tasa > 0) {
                    // if (t.WTCode === 'PC05') {
                    //         let value = orderInfo.SubTotal * t.Tasa / 100;  
                    //         proforma = {
                    //             ...proforma,
                    //             [t.WTCode]: value, 
                    //         }
                    //     } else 
                    // if (t.WTCode === 'PC06') {
                    //        let value = (orderInfo.SubTotal * 0.5) * t.Tasa / 100;
                    //         proforma = {
                    //             ...proforma,
                    //             [t.WTCode]: value, 
                    //         }
                    //      } else
                    // if (t.WTCode === 'PC07') {
                    //         let value = (orderInfo.SubTotal + orderInfo.IVA21) * t.Tasa / 100;
                    //         proforma = {
                    //             ...proforma,
                    //             [t.WTCode]: value, 
                    //         }
                    //     } else 
                    // if (t.WTCode === 'PC08') {
                    //         let value = ((orderInfo.SubTotal + orderInfo.IVA21) * 0.5) * t.Tasa / 100;
                    //         proforma = {
                    //             ...proforma,
                    //             [t.WTCode]: value, 
                    //         }
                    //     } else 
                         if (t.WTCode !== 'PC01') {
                            //  let value = orderInfo.SubTotal * t.Tasa / 100
                                let value = realyTotal * t.Tasa / 100
                                // total de la orden X tasa del impuesto / 100
                                let secondValue = t.Tasa / 100 // asi estaba antes  t.Tasa / 100
                                proforma = {
                                    ...proforma,
                                    [t.WTCode]: value, 
                                    PorcentajeIBB:{
                                        ...proforma.PorcentajeIBB,
                                        [t.WTCode]: t.Tasa,
                                    },
                                }
                        impSum = impSum + value

                    } else 
                    if( t.WTCode === 'PC01' && clienteCat === 'CM' ){
                        //console.log('testing')
                        // Datos iniciales
                    // let neto = orderInfo.SubTotal; // Neto
                        let neto = realyTotal; // Neto

                        let tasaDeExtension =  t.Tasa_de_extención - 100; // Tasa de exención (98.94%)
                        let porcentajeRestante = ( 100 - tasaDeExtension).toFixed(2)
                        //console.log(porcentajeRestante)
                        
                        let tasa = t.Tasa; // Alicuota inicial (1.75%)
                        
                        // Cálculo de la base sujeta a la alícuota
                        let baseSujetaAlicuota = neto * (1 - (tasaDeExtension / 100));
                        // Cálculo de la alícuota ajustada
                        let tasaAjustada = tasa - (tasa * 50 / 100);
                        // Cálculo del total
                        let valueEx = baseSujetaAlicuota * (tasaAjustada / 100);
                        
                        let totalValue = valueEx.toFixed(2);
                        
                        // console.log(tasaDeExtension)
                        // console.log(baseSujetaAlicuota)  
                        //   despues esto se multiplica con el 1.75
                        // console.log(tasaAjustada)
                        // console.log(totalValue);

                        proforma = {
                            ...proforma,
                            [t.WTCode]: totalValue,
                            PorcentajeIBB:{
                                ...proforma.PorcentajeIBB,
                                [t.WTCode]: tasaAjustada,
                                [`ext${t.WTCode}`]: tasaDeExtension
                            },
                        }
                        impSum = impSum + valueEx
                    } else 
                    {
                        let tasaEx = 100 - t.Tasa_de_extención  // tasaEx =  1,06 || t.Tasa = 1.750 
                        let valueA = (tasaEx * t.Tasa) / 100
                       // let value = (orderInfo.SubTotal * valueA) / 100 
                       let value = (realyTotal * valueA) / 100
                        proforma = {
                            ...proforma,
                            [t.WTCode]: value,
                            PorcentajeIBB:{
                                ...proforma.PorcentajeIBB,
                                [t.WTCode]: t.Tasa,
                                [`ext${t.WTCode}`]: tasaEx
                            },
                        }
                        impSum = impSum + value
                    }
                }
            })
        }
//console.log(proforma)
return {
    ...proforma,
   // TotalConImp: orderInfo.SubTotal + impSum,
   TotalConImp: realyTotal + impSum,
}
}

//console.log(orderInfo.proforma)

    // lo sacamos del return al setDisabledBtn por que en produccion no funcionaba
    useEffect(() => {
        setDisabledBtn(false)
    }, [])

  
    return (
        <>
            {
                isOpenModal.a
                &&
                <NotificationModal closeSection={closeSection} />
            }

            {
                isOpenModal.b
                &&
                <CreateOrder section={'MODIFICAR'} closeSection={closeModificationModal} />
            }
            {
                showSapWarningModal
                &&
                <dialog open className='modalBackdrop justify-content-center'>
                    <div className='modalContent clrBgLightGray p-0'>
                        <div className='p-2 clrBgPink d-flex justify-content-between'>
                            <h5 className='m-0 fw-bold'>VALIDACION PENDIENTE</h5>
                            <input
                                type='button'
                                className="btn-close centerEnd btnCardHead ms-4 p-0 me-2"
                                onClick={() => setShowSapWarningModal(false)}
                            />
                        </div>
                        <div className='p-4'>
                            <p className='mb-4'>
                                Este pedido no fue validado por el validador. Queres enviarlo a SAP de todas formas?
                            </p>
                            <div className='d-flex justify-content-end gap-2'>
                                <button
                                    type='button'
                                    className='btn btn-outline-secondary'
                                    onClick={() => setShowSapWarningModal(false)}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type='button'
                                    className='btn btn-outline btnBlue'
                                    onClick={() => {
                                        setShowSapWarningModal(false)
                                        handleOrderState('Cargado en SAP')
                                    }}
                                >
                                    Enviar a SAP
                                </button>
                            </div>
                        </div>
                    </div>
                </dialog>
            }

            <div className='d-flex flex-column gap-2'>
                {
                    <>
                        {canSellerModifyPendingOrder

                            &&

                            <button
                                name='Modificar'
                                className='btn  btnModificar btnOrderStatus w-100 mt-5 p-3'
                                //disabled = {dis}
                                onClick={handleModifications}
                            >
                                Modificar
                            </button>
                        }
                        {
                            canShowActionSection
                            &&
                            <>
                                {/* MODIFICAR */}
                                {
                                    !canValidateAuthorizedOrder
                                    &&
                                    <button
                                        name='Modificar'
                                        className='btn  btnModificar btnOrderStatus w-100 mt-5 p-3'
                                        disabled={disableButton() || disabledBtn}
                                        onClick={handleModifications}
                                    >
                                        Modificar
                                    </button>
                                }

                                {/* RECHAZAR */}
                                <div className='d-flex gap-2'>
                                    {
                                        canRejectOrder
                                        &&
                                        <div className='w-100' >
                                            <details className={`btn btnReject textBlack clrBgDecline btnOrderStatus py-3 w-100 ${disableButton() || disabledBtn || autorizando ? 'disabledDet' : ''}`}>
                                                <summary>{isValidationRejectionFlow ? 'Rechazar validacion' : 'Rechazar'}</summary>
                                                <NotificationModal
                                                    closeSection={closeSection}
                                                    disableButton={disableButton}
                                                    disabledBtn={disabledBtn}
                                                    autorizando={autorizando}
                                                    usePredefinedReasons={isValidationRejectionFlow}
                                                />
                                            </details>
                                        </div>
                                    }
                                    {
                                        isDirector && (directorCanSendValidated || directorCanSendWithoutValidation)
                                            ?
                                            //SAP
                                            <button
                                                type='button'
                                                className={`btn btnSAP textBlack clrBgForward btnOrderStatus w-100 maxHeigth58 ${cargandoSap ? 'p-0' : 'p-3'}`}
                                                disabled={disableButton() && !sapConnected || disabledBtn || cargandoSap}
                                                // disabled={dis && !sapConnected || disabledBtn || cargandoSap}
                                                onClick={handleSapClick}
                                                name="Cargado en SAP"
                                            >

                                                {
                                                    cargandoSap
                                                        ? <div className=' spinner-border'></div>
                                                        : <span>{directorCanSendWithoutValidation ? 'Validacion pendiente' : 'SAP'}</span>
                                                }
                                            </button>
                                            :
                                            //AUTORIZAR / VALIDAR
                                            <button
                                                type='button'
                                                className={`btn btnAccept textBlack clrBgAccept btnOrderStatus maxHeigth58 p-3 ${canValidateAuthorizedOrder ? 'w-100' : 'w-100'} ${autorizando ? 'p-0' : 'p-3'}`}
                                                disabled={
                                                    disableButton()
                                                    || (
                                                        (canReviewAuthorizedOrder && orderInfo.Estado !== 'Pendiente')
                                                        || (canValidateAuthorizedOrder && orderInfo.Estado !== 'Autorizado')
                                                        || (!canReviewAuthorizedOrder && !canValidateAuthorizedOrder)
                                                    )
                                                    || disabledBtn
                                                    || autorizando
                                                }
                                                onClick={() => handleOrderState(canValidateAuthorizedOrder ? "Validado" : "Autorizado")}
                                                name={canValidateAuthorizedOrder ? "Validado" : "Autorizado"}
                                            >
                                                {
                                                    autorizando
                                                        ? <div className='spinner-border'></div>
                                                        : <span>{canValidateAuthorizedOrder ? ' Validar' : ' Autorizar'}</span>
                                                }
                                            </button>
                                    }
                                </div>
                            </>
                        }
                    </>
                }
            </div >
        </>
    )
}
